module.exports = __webpack_public_path__ + "media/promo/courses/images/c-2-29149ce02a3c4ebea1aed947ad0a826f.jpg";